
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 780 500","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40 0h700c22.092 0 40 17.909 40 40v420c0 22.092-17.908 40-40 40H40c-22.091 0-40-17.908-40-40V40C0 17.909 17.909 0 40 0z","fill":"#000"}}),_c('path',{attrs:{"d":"M471.125 104.643H308.882v291.555h162.243V104.643z","fill":"#FF5F00"}}),_c('path',{attrs:{"d":"M319.185 250.42a185.084 185.084 0 0118.607-81.051 185.08 185.08 0 0152.213-64.726 185.423 185.423 0 00-271.758 47.404 185.42 185.42 0 00271.758 244.151 185.101 185.101 0 01-70.82-145.778z","fill":"#EB001B"}}),_c('path',{attrs:{"d":"M690 250.42a185.415 185.415 0 01-205.2 184.361 185.396 185.396 0 01-94.795-38.584 185.446 185.446 0 000-291.554 185.408 185.408 0 01195.619-20.996A185.408 185.408 0 01690 250.42zM672.31 365.317v-5.969h2.407v-1.216h-6.13v1.216h2.408v5.969h1.315zm11.9 0v-7.197h-1.878l-2.162 4.951-2.161-4.951h-1.88v7.197h1.326v-5.428l2.027 4.68h1.376l2.027-4.692v5.44h1.325z","fill":"#F79E1B"}})])
          )
        }
      }
    